import React from "react";

import "./Introduction.scss";
import { LanguageSelection } from "./LanguageSelection";
import { Language, State } from "../core";
import { getString } from "./strings";
import festivalLogo from "../assets/helsinki-festival-logo-grey.svg";
import robotChoirLogo from "../assets/robot-choir-logo.svg";

interface IntroductionProps {
  state: State;
  language: Language;
  onOpenInfoModal: () => void;
  onChangeLanguage: (language: Language) => void;
}
export const Introduction: React.FC<IntroductionProps> = ({
  state,
  language,
  onOpenInfoModal,
  onChangeLanguage
}) => {
  return (
    <div className="introduction">
      <a
        href={
          language === "suomi"
            ? "https://helsinkifestival.fi/"
            : "https://helsinkifestival.fi/en/"
        }
      >
        <img
          className="introduction--festivalLogo"
          src={festivalLogo}
          alt="Helsinki Festival"
        />
      </a>
      <LanguageSelection
        language={language}
        onChangeLanguage={onChangeLanguage}
      />
      <img
        className="introduction--logo"
        src={robotChoirLogo}
        alt="Robot Choir"
      />
      <div className="introduction--text">
        <h2>
          {getString(
            language,
            state.state === "restart" ? "thankYou" : "subTitle"
          )}
        </h2>
        <p
          dangerouslySetInnerHTML={{
            __html: getString(
              language,
              state.state === "restart" ? "hearMore" : "introduction"
            )
          }}
        />
        <button className="introduction--tellMeMore" onClick={onOpenInfoModal}>
          {getString(language, "openInfoModal")}
        </button>
      </div>
    </div>
  );
};
